import { History } from "history";
import { RouterStore, SessionStore, LocaleStore, PriceStore } from "./";

export default function createStores(history: History) {
  const routerStore = new RouterStore(history);
  const sessionStore = new SessionStore();
  const localeStore = new LocaleStore();
  const priceStore = new PriceStore();

  return {
    router: routerStore,
    session: sessionStore,
    locale: localeStore,
    price: priceStore
  };
}
